<div class="smart-table">
  <div class="smart-table__sticky-header" [smartTableSticky]="content" #header>
    <div class="smart-table__wrapper">
      <table class="table mb-0">
        <thead>
          <tr>
            <th *ngFor="let item of visibleHeaders"
                [ngClass]="item.class"
                [class.border-bottom-0]="isFiltration">
              <ng-container *ngIf="item.sort; else notSort">
                <smart-table-sort [(active)]="sort"
                                  (activeChange)="onChangeSort($event, item)"
                                  [item]="item.sort">{{ item.name }}</smart-table-sort>
              </ng-container>
              <ng-template #notSort>
                {{ item.name }}
              </ng-template>
            </th>
          </tr>
          <tr *ngIf="isFiltration">
            <th *ngFor="let item of visibleHeaders" class="pt-0 pb-3 align-top">
              <div class="form-group mb-0 table-outer-left" *ngIf="item.filter">
                <smart-table-filter
                  (changed)="onChangeFilter($event, item)"
                  [item]="item.filter"></smart-table-filter>
              </div>
            </th>
          </tr>
        </thead>
      </table>
    </div>
  </div>

  <div class="smart-table__scroller" #content>
    <div class="smart-table__wrapper">
      <table class="table table-hover mb-0">
        <tbody *ngIf="headers?.length || columns?.length">
        <ng-container *ngFor="let row of source, let index = index">
          <tr [smartTableNavigate]="routers[index]"
              [collapseAuto]="collapseAuto"
              [collapseByClick]="collapseByClick && collapses[index]"
              [class.un-collapsed]="collapseContent && !collapses[index]?.isCollapsed">
            <ng-container *ngFor="let item of (headers || columns)">
              <ng-container [ngTemplateOutlet]="cells[item.key].template"
                            [ngTemplateOutletContext]="{
                              $implicit: row,
                              index: index,
                              collapse: collapses[index]
                            }">
              </ng-container>
            </ng-container>
          </tr>
          <tr class="collapse-group" *ngIf="collapseContent && !collapses[index]?.isCollapsed">
            <td [colSpan]="headers?.length || columns?.length">
              <div class="collapse-block" [smartTableCollapseSticky]="content">
                <ng-container [ngTemplateOutlet]="collapseContent.template"
                              [ngTemplateOutletContext]="{
                                $implicit: row,
                                index: index,
                                collapse: collapses[index]
                              }">
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
        <tbody *ngIf="!source.length">
        <tr>
          <td [attr.colspan]="headers.length">
            No data found
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
